import React from 'react'
import {Field} from 'redux-form'

export const booleanRadio = (props) => {

	const {
		input,
		label,
		labelTitle,
		type,
		meta: {touched, error},
		disabled,
		required = false
	} = props

	let value = input.value
	if (typeof value === 'boolean') {
		value = value.toString()
	}
	return (

		<div className={'form-group radiobuttons ' + (touched && error ? 'is-invalid' : '')}>
			<a href="#" id={input.name}></a>
			{labelTitle &&
			<label>{labelTitle} {required && <span className="mandatory">*</span>}</label>
			}
			<div className="form-check">
	  <Field {...input}
			 component="input"
			 type="radio"
			 required={required}
			 disabled={disabled}
			 className={'form-check-input ' + (touched && error ? 'is-invalid' : '')}
			 id={input.name + `-true`}
			 value="true"
			 checked={value === 'true'} />
	  <label className="form-check-label" htmlFor={input.name + `-true`}>
					Ja
				</label>
			</div>
			<div className="form-check form-check-inline">
	  <Field {...input}
			 component="input"
			 type="radio"
			 required={required}
			 disabled={disabled}
			 className={'form-check-input ' + (touched && error ? 'is-invalid' : '')}
			 id={input.name + `-false`}
			 value="false"
			 checked={value === 'false'}/>
				<label className="form-check-label" htmlFor={input.name + `-false`}>
					Nein
				</label>
			</div>

			{touched && error && <p className="text-danger"><span>{error}</span></p>}
		</div>
	)
}


/*

 <input className={'form-check-input ' + (touched && error ? 'is-invalid' : '')} {...input}
 type="radio"
 required={required}
 disabled={disabled}
 id={input.name}
 value="true"/>



 */
